import { render, staticRenderFns } from "./QuoteEditor.vue?vue&type=template&id=5a04a12e&scoped=true"
import script from "./QuoteEditor.vue?vue&type=script&lang=js"
export * from "./QuoteEditor.vue?vue&type=script&lang=js"
import style0 from "./QuoteEditor.vue?vue&type=style&index=0&id=5a04a12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a04a12e",
  null
  
)

export default component.exports